// 사용방법 (공식문서)
// notion 테마 스타일링 (필수)
import "react-notion-x/src/styles.css";

// // 코드 하이라이트 스타일용 (선택)
// import "prismjs/themes/prism-tomorrow.css";

// // 공식등 수학적 기호 스타일용 (선택)
// import "katex/dist/katex.min.css";
import { useEffect, useState } from "react";
import { NotionAPI } from "notion-client";
import { NotionRenderer } from "react-notion-x";

import { Code } from "react-notion-x/build/third-party/code";
import { Collection } from "react-notion-x/build/third-party/collection";
import { Equation } from "react-notion-x/build/third-party/equation";
import { Modal } from "react-notion-x/build/third-party/modal";
import { Pdf } from "react-notion-x/build/third-party/pdf";

export default function NotionView({ content }: { content: string }) {
  const [recordMap, setRecordMap] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const notion = new NotionAPI();
    const id = "2091e6bf93cb80b298b3fd2eaca71561";
    setLoading(true);
    setError(null);
    notion
      .getPage(id)
      .then((data) => {
        setRecordMap(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setError("Notion 데이터를 불러오지 못했습니다.");
        setLoading(false);
      });
  }, []);

  if (loading) return <div>로딩 중...</div>;
  if (error) return <div>{error}</div>;
  if (!recordMap) return null;
  return <NotionRenderer recordMap={recordMap} fullPage={true} />;
}
